<form>
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.Bike_Title }}</h2>
    </div>

    <app-loading-animation class="edit-animation" *ngIf="loading"></app-loading-animation>

    <div class="form-section" [hidden]="loading">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.Bike_Id_Tile }}:</label>
                    <div class="value uppercase">{{ selectedBike.BikeId }}</div>
                </div>
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ConfigurationDetails_ConfigId }}:</label>
                    <div class="value">{{ selectedBike.ConfigId}}</div>
                </div>

            </div>
        </div>
    </div>
    <div class="form-section" [hidden]="loading">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.Bike_EolDate }}:</label>
                    <div class="value">{{ selectedBike.EOLDate }}</div>
                </div>
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ManageBikes_ApprovalBike }}:</label>
                    <div class="value">
                        <span *ngIf="!approvalEdit">
                            {{ selectedBike.ApprovalBikeString }} 
                            <img *ngIf="bikeModifyRole" (click)="editApproval()" class="edit-field" src="assets/icons/edit.svg" />
                        </span>
                        <span *ngIf="approvalEdit && bikeModifyRole" class="approval-edit">
                            <mat-select class="approval-select" [formControl]="approvalControl">
                                <mat-option value="false">{{ languageService.languageJSON.Global_No }}</mat-option>
                                <mat-option value="true">{{ languageService.languageJSON.Global_Yes }}</mat-option>
                            </mat-select>
                            <button (click)="saveApproval()">
                                {{ languageService.languageJSON.Global_Save }}</button>
                        </span>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div class="form-section table" [hidden]="loading">
        <div class="rule-title">{{ languageService.languageJSON.ManageBikes_SoftwareVersions }}</div>
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col">
                    {{ languageService.languageJSON.ManageBikes_BikeComponent }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.ManageBikes_Filename }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.ConfigurationDetails_Version }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.ManageBikes_RolloutId }}
                </div>
            </div>
            <div class="flex-row" *ngFor="let component of selectedBike.ComponentsHistories">
                <div class="flex-col">
                    {{ component.Component }}
                </div>
                <div class="flex-col">
                    <a *ngIf="component.ReleaseId!=null" (click)="openRelease(component.ReleaseId)">{{ component.Filename }}</a>
                    <span *ngIf="component.ReleaseId==null">{{ component.Filename }}</span>
                </div>
                <div class="flex-col">
                    {{ component.Version }}
                </div>
                <div class="flex-col">
                    {{ component.RolloutId }}
                </div>
            </div>
        </div>
    </div>

    <div class="form-section table" [hidden]="loading || selectedBike.BikeHistories.length==0">
        <div class="rule-title">{{ languageService.languageJSON.ReleaseDetails_Logbook }}</div>
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_Date }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_User }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_Action }}
                </div>
                <div class="flex-col">
                    {{ languageService.languageJSON.Global_Details }}
                </div>
            </div>
            <div class="flex-row" *ngFor="let bike of selectedBike.BikeHistories">
                <div class="flex-col">
                    {{ bike.Date | date : 'long' }}
                </div>
                <div class="flex-col">
                    {{ bike.User }}
                </div>
                <div class="flex-col">
                    {{ bike.Action }}
                </div>
                <div class="flex-col">
                    {{ bike.Details }}
                </div>
            </div>
        </div>
    </div>

</form>